import NotificationServiceModel from '@/models/NotificationServiceModel';
import doc                      from '@widesk-core/decorators/doc';

@doc.path('/stonecode_notification_subscription_status_histories/{?id}')
export default class SubscriptionStatusHistoryModel extends NotificationServiceModel {}